import React from "react";
import jQuery from "jquery";
import Fa from "../common/Fa";
global.jQuery = jQuery;
global.jquery = jQuery;
global.$ = jQuery;

/**
 * Componente Aside que corresponde al sidebar
 */
export class Aside extends React.Component {
  /**
   * Renderiza el componente
   */
  render() {
    return (
      <aside className=" aside hero ">
        <div className="main">{this.props.children}</div>
      </aside>
    );
  }
}

export class Item extends React.Component {
  /**
   * Renderiza el componente
   */
  render() {
    return (
      <a
        className="item"
        onClick={evt => this.props.onClick(evt)}
        title={this.props.children}
        id={this.props.id}
      >
        <span className="icon">
          <Fa icon={this.props.icon} />
        </span>
        <span className="name">{this.props.children}</span>
      </a>
    );
  }
}
